import type { DashboardCoaching } from '@/core/types'
import {
  isCategoryFilterActive,
} from '@/core/lib/viewInput'
import type { FilterCategory } from '@/core/views/viewConfig'

export type CoachingViewFilter = {
  excludedCoaches: string[]
  excludedKostentraeger: string[]
  datumVon: string | null
  datumBis: string | null
  kohorte: string | null
}

export const EMPTY_COACHING_VIEW_FILTER: CoachingViewFilter = {
  excludedCoaches: [],
  excludedKostentraeger: [],
  datumVon: null,
  datumBis: null,
  kohorte: null,
}

export const COACHING_FILTER_CATEGORIES: FilterCategory<DashboardCoaching>[] = [
  { id: 'coach', label: 'Coach', catalog: () => [], accessor: (c) => c.secondCoach ? [c.coach, c.secondCoach] : c.coach },
  { id: 'kostentraeger', label: 'Kostenträger', catalog: () => [], accessor: (c) => c.kostentraeger },
]

export function excludedByCategoryFrom(filter: CoachingViewFilter): Record<string, string[]> {
  return {
    coach: filter.excludedCoaches,
    kostentraeger: filter.excludedKostentraeger,
  }
}

export function isActive(filter: CoachingViewFilter | null | undefined): filter is CoachingViewFilter {
  if (!filter) return false
  return (
    isCategoryFilterActive(excludedByCategoryFrom(filter)) ||
    filter.datumVon !== null ||
    filter.datumBis !== null
  )
}

function intersectsRange(
  beginn: string | null,
  ende: string | null,
  von: string | null,
  bis: string | null,
): boolean {
  if (beginn === null && ende === null) return false
  const b = beginn ?? ende!
  const e = ende ?? beginn!
  if (von !== null && e < von) return false
  if (bis !== null && b > bis) return false
  return true
}

export function filterCoachingsByDatum(
  list: DashboardCoaching[],
  filter: Pick<CoachingViewFilter, 'datumVon' | 'datumBis'> | null | undefined,
): DashboardCoaching[] {
  if (!filter || (filter.datumVon === null && filter.datumBis === null)) return list
  return list.filter((c) => intersectsRange(c.gueltigkeitBeginn, c.gueltigkeitEnde, filter.datumVon, filter.datumBis))
}

export function filterCoachingsByKohorte<T extends { beginn: string | null }>(
  list: T[],
  filter: Pick<CoachingViewFilter, 'kohorte'> | null | undefined,
): T[] {
  const kohorte = filter?.kohorte ?? null
  return kohorte === null ? list : list.filter((c) => c.beginn === kohorte)
}

export function filterCoachingsExtra(
  list: DashboardCoaching[],
  filter: CoachingViewFilter | null | undefined,
): DashboardCoaching[] {
  return filterCoachingsByKohorte(filterCoachingsByDatum(list, filter), filter)
}
